import React from 'react';
import DeliveryPage from '../src/client/pages/Delivery';
import BaseLayout from '../src/client/components/Templates/Base';
import { getDeliveryStart } from '../src/client/actions/delivery';

const Delivery = () => (
  <BaseLayout>
    <DeliveryPage />
  </BaseLayout>
);

Delivery.getInitialProps = async ({
  ctx: {
    store: { dispatch },
  },
}) => {
  const actionsToDispatch = [getDeliveryStart];
  actionsToDispatch.map(action => dispatch(action()));
  return {
    namespacesRequired: ['common', 'navigation']
  };
};

export default Delivery;
